//-----------------------------------------------------------------------------
//
// tooltip.js
//
// Copyright 2023 Emergence Software Pte. Ltd. - All rights reserved.
//
//-----------------------------------------------------------------------------

// Imports
import React, { useEffect, useRef } from "react"
import { isBrowser } from "../services/authentication/auth.browser"

// Conditional import
const BsTooltip  = (isBrowser()) ?  require('bootstrap').Tooltip : (children) => { return <>{children}</> };



//-----------------------------------------------------------------------------
//
// SUPPORT FUNCTIONS
//
//-----------------------------------------------------------------------------

// Function Tooltip
const Tooltip = (isBrowser()) ? ({ children, text, placement="bottom" }) => {
  const childRef = useRef(undefined)

  useEffect(() => {
      const t = new BsTooltip(childRef.current, {
        title: text,
        html: true,
        placement: placement,
        trigger: "hover"
      })
      return () => setTimeout(function () { t.dispose(); }, 300)
  }, [text, placement])

  return React.cloneElement(children, { ref: childRef })
} : ({ children, text }) => { return <></> }


// Default export
export default Tooltip
